import { render, staticRenderFns } from "./CustomerStructureReport.vue?vue&type=template&id=248afda8"
import script from "./CustomerStructureReport.vue?vue&type=script&lang=js"
export * from "./CustomerStructureReport.vue?vue&type=script&lang=js"
import style0 from "./CustomerStructureReport.vue?vue&type=style&index=0&id=248afda8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports